// Altura. Régua VERTICAL — a mesma do app, com a moldura do redesign.
// Payload inalterado: `CURRENT_HEIGHT` em cm, string inteira.

import React, { useEffect, useState } from "react";

import RulerPicker from "../components/RulerPicker.jsx";
import { CardRegua } from "../widgets/Widgets.jsx";

const StepCurrentHeight = ({ setCanProceed, setStepData }) => {
  const [valor, setValor] = useState(170);

  useEffect(() => {
    setCanProceed(true);
    setStepData({ CURRENT_HEIGHT: String(Math.round(valor)) });
  }, [valor, setCanProceed, setStepData]);

  return (
    <CardRegua valor={Math.round(valor)} unidade="cm" vertical>
      <RulerPicker
        axis="y"
        min={245}
        max={100}
        step={-1}
        decimals={0}
        majorEvery={5}
        initialValue={170}
        onChange={setValor}
      />
    </CardRegua>
  );
};

export default StepCurrentHeight;
